import React, { Fragment } from 'react';
import { ShimmyValue } from 'library/components/shimmy';
import withData from 'util/hoc/with-data';
import HiringQuery from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';
import SurveyList from 'apps/hiring/components/survey-list';
import SurveyStatsSidebar from 'apps/hiring/components/survey-stats-sidebar';
import CollapsableSidebar from 'apps/hiring/components/collapsable-sidebar';
import SurveyStatusSidebar from 'apps/hiring/components/survey-status-sidebar';

class SurveyStatus extends React.Component {
  state = {
    selected: null
  }

  handleUserClick = (user) => {
    this.setState({
      selected: user
    });
  }

  handleSidebarClose = () => {
    this.setState({
      selected: null
    });
  }

  render() {
    const {
      graph_loading,
      graph_data,
      match
    } = this.props;

    const {
      selected
    } = this.state;

    return (
      <Fragment>
        <SurveyStatsSidebar stats={resolve(graph_data, 'assessment_stats', {})} />
        <CollapsableSidebar open={selected} onClose={this.handleSidebarClose}>
          <SurveyStatusSidebar user={selected} />
        </CollapsableSidebar>
        <div className="hiring-survey-list">
          <SurveyList
            type="applicant"
            users={resolve(graph_data, 'applicants', [])}
            pagination={resolve(graph_data, 'pagination', {})}
            linkBase={`/hiring/openings/${resolve(match, 'params/id', '0')}/applicants`}
            getLinkId={(user)=>user.application_id}
            onClick={this.handleUserClick}
            loading={graph_loading}
            invitationToken={resolve(graph_data, 'opening/settings/invitation_token', '')}
            openingId={resolve(graph_data, 'opening/id', '')}
          />
        </div>
      </Fragment>
    );
  }
}

SurveyStatus.parseQueryData = (data) => ({
  applicants: resolve(data, 'opening/applications/results', []).filter(c => c.status == 'Applied').map(r=>({
    ...r.user,
    application_id: r.id,
    assessment: r.assessment,
    status: r.status
  })),
  assessment_stats : resolve(data, 'opening/assessment_stats', {}),
  pagination: resolve(data, 'opening/applications/pagination', {}),
  opening: {
    id: resolve(data, 'opening/id'),
    settings: {
      invitation_token: resolve(data, 'opening/settings/invitation_token', '')
    }
  }
});

SurveyStatus.query = (token, { match }) => (
  HiringQuery(`
    {
      opening (id:${resolve(match, 'params/id', '0')}){
        id,
        settings {
          invitation_token
        },
        assessment_stats(application_status: "Applied") {
          complete
          ideal
          incomplete
          invalid
          real
          scored
          valid
        },
        applications {
          pagination {
            limit,
            offset,
            total
          }
          results {
            id,
            status,
            assessment {
              id,
              completion_date,
              progress
            }
            user {
              id,
              first_name,
              last_name
            }
          }
        }
      }
    }
  `)
);

export default withData(SurveyStatus);
